import { render, staticRenderFns } from "./DocumentActionbarSearchView.vue?vue&type=template&id=047a8200"
import script from "./DocumentActionbarSearchView.vue?vue&type=script&lang=js"
export * from "./DocumentActionbarSearchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports